const URL = process.env.NODE_ENV === 'production' ? 'https://weixinapi.tuochebao.com/' : 'http://localhost:21021/';
export default URL;


// WEBPACK FOOTER //
// ./src/lib/url.ts